import { ENDPOINTS } from '@/constants/endpoints'
import {deleteWithAuth, getWithAuth, postWithAuth, putWithAuth} from '@/api'

import {
    EditTeammateRequest,
    InviteTeammateRequest,
    TeammatesRequest,
    TeammatesResponse,
    RoleType,
    PermissonDictionaryType
} from '@/stores/team-management/models'

export const getTeammates = (request: TeammatesRequest) =>
    getWithAuth<TeammatesResponse>(ENDPOINTS.TEAMMATES_API, request)

export const inviteTeammate = (request: InviteTeammateRequest) =>
    postWithAuth<TeammatesResponse>(ENDPOINTS.TEAMMATES_API, request)

export const resendInvitation = (teammateId: string) =>
    postWithAuth<TeammatesResponse>(`${ENDPOINTS.TEAMMATES_API}/${teammateId}/resend`)

export const editTeammate = (request: EditTeammateRequest) => {
    const {id, ...rest} = request
    return putWithAuth<TeammatesResponse>(`${ENDPOINTS.TEAMMATES_API}/${id}`, rest)
}

export const deleteTeammate = (teammateId: string) =>
    deleteWithAuth<TeammatesResponse>(`${ENDPOINTS.TEAMMATES_API}/${teammateId}`)

export const fetchPermissions = () => getWithAuth<RoleType[]>('/oppapi/v1/permissions')

export const fetchPermissionsDictionary = () =>
    getWithAuth<PermissonDictionaryType[]>('/oppapi/v1/permissions/dictionary')
